import CallServiceTable from "../../components/Tables/CallServiceTable";
import { H3, Anchor } from "../../components/Text";
import { useDialog } from "../../contexts/DialogContext";
import { useModal } from "../../contexts/ModalContext";
import TableComplete from "../../components/Tables/TableComplete";
import { Circle } from "../../components/Animation";
import { Button } from "../../components/Buttons";
// import { DialogConfirmation } from "../../components/Modal";
import RenderPdf from "../../containers/ManegeProcedure/RenderPdf";
import RenderLiquidaciónProforma from "../../containers/ManegeProcedure/RenderLiquidaciónProforma";
import { useAuth } from "../../contexts/AuthContext";
import { Request } from "../../hooks/Request";
import ListDocument from "../../components/common/ListDocument";
import Loading from "../../components/Animation/Loading";
import FormDefault from "../../components/Forms/FormDefault";
import * as Yup from "yup";
import { requestAuth } from "../../components/services/RequestService";
import { toast } from "react-toastify";
import GenerateRoadmap from "../../containers/ManegeProcedure/GenerateRoadmap";

const ClientList = () => {
  const { user } = useAuth();
  const { openDialog } = useDialog();
  const { openModal, onClose } = useModal();

  function listDocumentPdf(procedure) {
    openDialog(<RenderPdf procedure={procedure} />);
  }
  function generateSettlementProforma(procedure) {
    openDialog(<RenderLiquidaciónProforma procedure={procedure} />);
  }
  function viewProcedure(procedure) {
    openModal(
      <ProcedureData procedure={procedure} onClose={onClose} user={user} />
    );
  }
  // function generateReport() {
  //   openDialog(
  //     <DialogConfirmation
  //       children={
  //         <H3>¿Estas seguro que quieres generar el reporte de tus tramites?</H3>
  //       }
  //       onClose={dialogClose}
  //       method="get"
  //       url={`/gamarra/${user?.company[0]?.id}/clientData `}
  //       texBtn="Generar"
  //       handleSuccess={viewLinkExcel}
  //     />
  //   );
  // }
  function viewLinkExcel(data) {
    openDialog(
      <div className="w-[300px]">
        <H3>Archivo generado</H3>
        <center>
          <Anchor
            className="text-[#264fbe] text-[1.4rem]"
            href={data.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            Descargar archivo
          </Anchor>
        </center>
        <br />
      </div>
    );
  }

  function handleDocument(procedure) {
    openModal(<ListDocument procedure={procedure} deleteDocument={false} />);
  }

  function generateRoadmap(procedure) {
    openDialog(<GenerateRoadmap procedure={procedure} />);
  }

  function generateGeneralReport() {
    openDialog(
      // <DialogConfirmation
      //   children={
      //     <H3>¿Estas seguro que quieres generar el reporte de archivo?</H3>
      //   }
      //   onClose={dialogClose}
      //   method="post"
      //   url="/gamarra/fiscalReport"
      //   texBtn="Generar"
      //   handleSuccess={viewLinkExcel}
      // />
      <div className="pb-6 xl:w-[320px]">
        <FormDefault
          tittle="GENERAR REPORTE DE TRÁMITES DE IMPORTACIÓN"
          fields={[
            // {
            //   label: "Compañia",
            //   name: "CompanyId",
            //   typeInput: "select",
            //   urlApi: "/company/getallcompanies",
            //   value: "id",
            //   labelOption: "razonSocial",
            // },
            // {
            //   label: "Tipo de procedimiento",
            //   name: "ProcedureTypeId",
            //   typeInput: "select",
            //   urlApi: "/procedureType",
            //   value: "id",
            //   labelOption: "name",
            //   required: false
            // },
            {
              label: "Desde",
              name: "initDate",
              type: "date",
            },
            {
              label: "Hasta",
              name: "endDate",
              type: "date",
            },
            // {
            //   label: 'Tipo de tramite',
            //   name: 'Category',
            //   typeInput: 'select',
            //   options: [
            //     {
            //       label: 'Normal',
            //       value: 'normal',
            //     },
            //     {
            //       label: 'Multiple',
            //       value: 'multiple',
            //     },
            //   ],
            // },
          ]}
          initialValues={{
            CompanyId: "",
            ProcedureTypeId: 1,
          }}
          validationSchema={Yup.object().shape({
            // CompanyId: Yup.string().required("Este campo es obligatorio"),
            // ProcedureTypeId: Yup.string().required("Este campo es obligatorio"),
          })}
          onSubmit={async (values) => {
            await requestAuth("get", `/gamarra/generalFormat`, null, { companyId: user?.company[0]?.id, procedureTypeId: values.ProcedureTypeId, initDate: values.initDate, endDate: values.endDate })
              .then((res) => {
                viewLinkExcel(res.data)
                toast.success("Trámite agregado correctamente!!!");
              })
              .catch(() => {
                toast.error("Se ha producido un error al crear el Proceso");
              });
          }}
          buttonName="Generar documento"
        />
      </div>
    );
  }

  function generateXlsxFiscalReport() {
    openDialog(
      <div className="pb-6 xl:w-[320px]">
        <FormDefault
          tittle="GENERAR REPORTE DE TRÁMITES DE EXPORTACIÓN"
          fields={[
            {
              label: "Desde",
              name: "initDate",
              type: "date",
            },
            {
              label: "Hasta",
              name: "endDate",
              type: "date",
            },
            // {
            //   label: 'Tipo de tramite',
            //   name: 'Category',
            //   typeInput: 'select',
            //   options: [
            //     {
            //       label: 'Normal',
            //       value: 'normal',
            //     },
            //     {
            //       label: 'Multiple',
            //       value: 'multiple',
            //     },
            //   ],
            // },
          ]}
          initialValues={{
            CompanyId: user?.company[0]?.id,
            ProcedureTypeId: 2,
          }}
          validationSchema={Yup.object().shape({
            // CompanyId: Yup.string().required("Este campo es obligatorio"),
            // ProcedureTypeId: Yup.string().required("Este campo es obligatorio"),
          })}
          onSubmit={async (values) => {
            await requestAuth("get", `/gamarra/fiscalReport`, null, { companyId: values.CompanyId, procedureTypeId: values.ProcedureTypeId, initDate: values.initDate, endDate: values.endDate })
              .then((res) => {
                viewLinkExcel(res.data)
                toast.success("Trámite agregado correctamente!!!");
              })
              .catch(() => {
                toast.error("Se ha producido un error al crear el Proceso");
              });
          }}
          buttonName="Generar documento"
        />
      </div>
    );
  }

  if (!user?.user?.id)
    return <Loading />

  return (
    <div>
      <CallServiceTable
        onClick={viewProcedure}
        component={({ reload }) => {
          return (
            <>
              <Button
                title="Generar reporte de trámites de exportación"
                className="text-lg py-3"
                onClick={() => generateXlsxFiscalReport(reload)}
              >
                <i className="far fa-file-lines"></i>
              </Button>
              <Button
                title="Generar reporte de trámites de importación"
                className="text-lg py-3"
                onClick={() => generateGeneralReport(reload)}
              >
                <i className="far fa-file"></i>
              </Button>
            </>
          );
        }}
        // urlApi={`procedure/byuserid/${user?.user?.id}/companyId/${user?.company[0]?.id}/pag`}
        urlApi={`/procedure/openprocedures`}
        addFilters={[
          {
            name: "procedureNumber",
            label: "Tramite",
            filter: true,
          },
          {
            name: "internCode",
            label: "Nro. interno",
            filter: true,
          },
          {
            name: "dimNumberFs",
            label: "Nro. DIM/DEX",
            filter: true,
          },
          {
            name: "codigoCliente",
            label: "Codigo de cliente",
            filter: true,
          },
          {
            name: "proveedor",
            label: "Proveedor",
            filter: true,
          },
          {
            name: "invoiceNumber",
            label: "Nro. de factura",
            filter: true,
          },
        ]}
        filters={[
          // {
          //   name: "ForQueryDate",
          //   label: "Validar fecha por ...",
          //   options: [
          //     {
          //       label: "Fecha de inicio",
          //       name: "procedureStartDate",
          //     },
          //     {
          //       label: "Fecha de validación",
          //       name: "validateDate",
          //     },
          //     {
          //       label: "Fecha de facturación",
          //       name: "fechaFacturacion",
          //     },
          //   ],
          // },
          {
            name: "procedureType",
            url: "/procedureType",
            default: "Todos los tramites",
            valueOption: "id",
            labelOption: "name",
          },
          {
            name: "status",
            label: "Estado de trámites",
            type: "multiSelect",
            options: [
              {
                label: "Pendientes",
                name: "pendiente",
                initial: true,
              },
              {
                label: "Terminado",
                name: "retirado",
              },
            ],
          },
          {
            // url: '/company/getallcompanies',
            // name: 'companyId',
            // valueOption: 'id',
            // labelOption: 'razonSocial',
            type: "rangeDate",
          },
        ]}
        header={[
          // {
          //   name: 'companyName',
          //   label: 'Compañía',
          //   filter: false,
          // },
          {
            name: "numberString",
            label: "Trámite",
          },
          {
            name: "procedureTypeName",
            label: "Tipo",
          },
          {
            name: "clientCode",
            label: "Código de cliente",
          },
          {
            name: "dimNumber",
            label: "Nro DIM/DEX",
          },
          {
            name: "billProvider",
            label: "Proveedor",
          },
          {
            name: "billNumber",
            label: "Número de factura",
          },
          {
            name: "validateDate",
            label: "Fecha de validación",
          },
          {
            name: "clientBillDate",
            label: "Fecha de facturación",
          },
          {
            name: "Reports",
            type: "action",
            label: "Reportes",
            actions: [
              {
                label: "Ver documentos",
                icon: "fa-solid fa-folder",
                action: handleDocument,
                color: "text-[#1d4ed8]",
              },
              {
                label: "Generar hoja de ruta",
                icon: "fas fa-route",
                action: generateRoadmap,
                color: "text-[#1d4ed8]",
              },
              {
                label: "Generar informe de la recepción de documentos",
                icon: "fas fa-tasks",
                action: listDocumentPdf,
                color: "text-[#1d4ed8]",
              },
              {
                label: "Generar liquidación - proforma",
                icon: "fas fa-coins",
                action: generateSettlementProforma,
                color: "text-[#1d4ed8]",
              },
            ],
          },
        ]}
        addUrl={`userId=${localStorage.getItem("id")}&companyId=${user?.company[0]?.id}`}
        statusPaination={false}
        showTable={true}
      />
    </div>
  );
};

const ProcedureData = ({ procedure }) => {
  const { data, loading } = Request({
    urlApi: `/clientStats/procedures/${procedure.id}/data`,
  });
  if (!loading) {
    return <Circle />;
  }
  function hadleDocument(list) {
    let listDocument = [];
    list.forEach((dataSet) => {
      if ((dataSet.type = "fileStatus")) {
        listDocument = [...listDocument, ...dataSet.fileStates];
      } else {
        listDocument = [
          ...listDocument,
          { ...dataSet, url: dataSet.value, name: dataSet.label },
        ];
      }
    });
    return listDocument;
  }
  return (
    <div>
      <div className="bg-white mb-2 rounded-md p-2">
        <h3 className="text-xl font-semibold text-center">Datos</h3>
        {data.map((item) =>
          item.type !== "fileStatus" && item.type !== "file" ? (
            <div key={item.id} className="flex gap-2 mx-1 my-1">
              <H3>{item.label}:</H3>
              <H3 className="font-normal">{item.value}</H3>
            </div>
          ) : null
        )}
      </div>
      <div className="bg-white rounded-md">
        <h3 className="text-xl font-semibold text-center mb-2">Documentos</h3>
        <TableComplete
          header={[
            {
              name: "name",
              label: "Documento",
            },
            {
              name: "url",
              label: "Enlace",
              type: "custom",
              builder: (item) => {
                if (item) {
                  return (
                    <Anchor
                      href={item}
                      className="text-[#1d4ed8] underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Abrir
                    </Anchor>
                  );
                } else {
                  return "-";
                }
              },
            },
            {
              name: "number",
              label: "Nro",
            },

            {
              label: "Fecha",
              name: "creationDate",
              type: "date",
            },
            {
              name: "presentation",
              label: "Presentación",
            },
            {
              name: "status",
              label: "Estado",
            },
            {
              label: "Proveedor",
              name: "provider",
            },
          ]}
          data={hadleDocument(data)}
        />
      </div>
    </div>
  );
};

export default ClientList;
